<template>
<!--  轮播图-集团/项目-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="基本信息" name="1">
      <van-field v-if="inputForm.type == '3'" v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="图片" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="display: flex; padding-left: 16px">
        <van-image width="100px" height="100px" fit="cover" :src="inputForm.pictureUrl" @click="preview()" />
      </div>
      <van-field v-model="inputForm.urlTypeName" label="链接类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.urlType !== '10'" label="链接" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
        <template #input>
          <div style="color: #5d94f8" @click="viewDetail">查看详情</div>
        </template>
      </van-field>
      <van-field v-model="inputForm.isEnabled==1?'是':'否'" label="是否启用" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse-item>
  </van-collapse>
  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
import {ImagePreview} from "vant";
export default {
  name: "banner",
  data(){
    return {
      activeNames: ['1'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        isDoTask: false,
        isLastTask: false,
        pictureUrl: ''
      },
      projectType: ''
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.projectType = query.projectType
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      if(this.projectType === '1') {
        this.$flow.queryById(id, '/carousechart/wuyeSmallCarousechart/queryById').then(({ data }) => {
          this.inputForm = data
        }).catch(e => {
          console.log(e)
        })
      } else {
        this.$flow.queryById(id, '/carousechart/wuyeSmallCarousechartProject/queryById').then(({ data }) => {
          this.inputForm = data
        }).catch(e => {
          console.log(e)
        })
      }
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
            _this.$flow.startFlow({
              id: _this.inputForm.id,
              flowType: _this.inputForm.flowType,
              formKey: _this.inputForm.formKey
            }, '/carousechart/wuyeSmallCarousechart/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          if(_this.projectType === '1') {
            _this.$flow.startFlow({
              id: _this.inputForm.id,
              flowType: _this.inputForm.flowType,
              formKey: _this.inputForm.formKey
            }, '/carousechart/wuyeSmallCarousechart/startFlow');
          } else {
            _this.$flow.startFlow({
              id: _this.inputForm.id,
              flowType: _this.inputForm.flowType,
              formKey: _this.inputForm.formKey
            }, '/carousechart/wuyeSmallCarousechartProject/startFlow');
          }

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(){
      ImagePreview({
        images: this.inputForm.pictureUrl.split('|'),
        startPosition: 0
      })
    },
    viewDetail(){
      this.$router.push({
        path: '/noticeDetail',
        query: {
          id: this.inputForm.infoUrl,
          urlType: this.inputForm.urlType
        }
      })
    }
  }
}
</script>

<style scoped>

</style>